const FavoriteHeaderIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M27 22C28.49 20.54 30 18.79 30 16.5C30 15.0413 29.4205 13.6424 28.3891 12.6109C27.3576 11.5795 25.9587 11 24.5 11C22.74 11 21.5 11.5 20 13C18.5 11.5 17.26 11 15.5 11C14.0413 11 12.6424 11.5795 11.6109 12.6109C10.5795 13.6424 10 15.0413 10 16.5C10 18.8 11.5 20.55 13 22L20 29L27 22Z"
        stroke="#663497"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FavoriteHeaderIcon;
